import type { FaireProductEntity } from "../../entity_types/product";

export const p_5nnpvjf32b: FaireProductEntity = {
  token: "p_5nnpvjf32b",
  type: "product",
  name: "Christian gift tray Child of God trinket tray colorful",
  brandToken: "b_5sfnb3y1",
  brandName: "Aspen Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/fdf2be857ef10a22d9c3b9e7d06699dab2d385d81f9bc6b9d2b21aaa6ebe2e5d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4255fac75f9f5f4013a8510fe3a8213a31fee04b9045005f979a8fd61b6d39cb.png",
    "https://cdn.faire.com/fastly/678081d6636459997ea5674cf2cbf30f7f662916b61e2207024ad482803afaa0.png",
  ],
  priceDollars: 12.47,
  description:
    'Faith based Christian gift is here with our trinket traythat can hold keys, jewelry, and other trinkets: Child of God preppy tween and kids gifts, funny gifting, stocking stuffers, gifts for mom and girlfriend gifting sections.\n\nCoordinates with coordinating flat zip leather pouch/bag.\n\nMaterial is a high quality Saffiano printed PU leather-like material.  Gold accent snaps for an elevated look.\n\nSize: 7"x7" flat, inside square dimensions when snapped are 4.5"x4"x5"\n\nAspen Lane is based  out of Denver, CO and is a female-founded small business that has been in business since 2014',
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:44.871Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
